// @flow

import i18n from 'i18next'

const percentageValue = (value: number | string): string => {
  return i18n.t('shared:percentage', { value })
}

export { percentageValue }
